import { Skeleton } from '~/shared/ui/SkeletonList'

export function Skeletons() {
  return (
    <>
      <Skeleton animated $height={68} style={{ marginBottom: '6px' }} />
      <Skeleton animated $height={68} style={{ marginBottom: '6px' }} />
      <Skeleton animated $height={68} style={{ marginBottom: '6px' }} />
      <Skeleton animated $height={68} style={{ marginBottom: '6px' }} />
      <Skeleton animated $height={68} style={{ marginBottom: '6px' }} />
      <Skeleton animated $height={68} style={{ marginBottom: '6px' }} />
      <Skeleton animated $height={68} style={{ marginBottom: '6px' }} />
    </>
  )
}
